module.exports = __webpack_public_path__ + "static/longines-982da541793dde969af4adb9cd0b2e6c.png";